import { experimentSettings } from "@/constants/experiments";
import { externalParamPackageLabels } from "@/constants/package-names";
import { storeActions } from "@/constants/store-actions";
import { storeMutations } from "@/constants/store-mutations";
import { flushSaveSessionQueue, saveSession } from "@/helpers/heritage-integration/order-helper";
import {
    getExperimentSettingsFromExperimentList,
    hasSettingEqualTo,
} from "@/helpers/experiment-helper";
import { routeData } from "@/router/constants/routes";
import store from "@/store";

export const GLASS_ONLY_SERVICE_PACKAGE = `ServicePackage-${externalParamPackageLabels.GLASS_ONLY}`;

export function isVinRequiredWithoutParts() {
    return (
        store.getters.vehicle?.vinRequired === true &&
        !store.getters.order?.lineItems?.glassParts?.length
    );
}

export function shouldSkipPartsAndQuoteForYmmInsurance() {
    return store.getters.payment?.isInsurance === true && isVinRequiredWithoutParts();
}

function quotePageData(overrides) {
    const existing = store.getters.pageData?.(routeData.QUOTE.name) ?? {};
    return {
        ...existing,
        ...overrides,
    };
}

export async function saveYmmInsuranceSelection(isInsurance) {
    const quoteData = quotePageData({
        servicePackageSelected: isInsurance === true ? GLASS_ONLY_SERVICE_PACKAGE : null,
    });

    await store.dispatch(storeActions.SAVE_PAYMENT_TYPE, isInsurance);
    await store.dispatch(storeActions.SAVE_PAGE_DATA, {
        page: routeData.QUOTE.name,
        data: quoteData,
    });
}

export function isYmmInsuranceEstimateEnabled() {
    const settings = getExperimentSettingsFromExperimentList(
        store.getters.applicationUser?.experiments ?? []
    );
    return (
        store.getters.vehicle?.vinRequired === true &&
        hasSettingEqualTo(experimentSettings.SHOW_INSURANCE_ON_YMM_ESTIMATE, "true", settings)
    );
}

function createYmmInsuranceReferral() {
    // Later saves wait for the bill-to lookup. The page can render while the referral is created.
    const referralReady = flushSaveSessionQueue().then(async () => {
        const billToAccountNumber = await store.dispatch(storeActions.GET_BILL_TO_ACCOUNT_NUMBER, {
            payload: {},
            pageNameToLog: routeData.ESTIMATE.name,
        });
        await store.dispatch(storeActions.SAVE_BILL_TO_ACCOUNT_NUMBER, billToAccountNumber);
    });
    store.commit(storeMutations.UPDATE_SAVE_SESSION_PROMISE, referralReady);
    referralReady
        .then(() =>
            saveSession({
                pageNameToLog: routeData.ESTIMATE.name,
                shouldAwaitSaveSessionQueue: true,
            })
        )
        .catch(() => {});
}

export async function prepareYmmInsuranceClaim() {
    if (!isYmmInsuranceEstimateEnabled()) {
        return;
    }

    await saveYmmInsuranceSelection(true);
    createYmmInsuranceReferral();
}
